import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"

export const Logo = () => (
  <Flex align="center">
    {/* Obrazek wewnątrz Boxa z zaokrąglonymi rogami */}
    <Box borderRadius="lg" overflow="hidden">
      <StaticImage
        src="../images/flexplum_logo_icon.png" // Zmień na odpowiednią ścieżkę do swojego obrazka
        alt="Logo FlexPlum"
        width={40} // Dopasuj szerokość obrazka
        height={40} // Dopasuj wysokość obrazka
        formats={["auto", "webp", "avif"]}
        placeholder="blurred"
        layout="fixed"
      />
    </Box>
    <Text
      lineHeight={1.1}
      fontWeight={600}
      fontSize={{ base: "xl", sm: "2xl", lg: "3xl" }}
      size="xl"
      bgClip="text"
      color={"purple.500"}
      p={0}
      ml={2} // Dodaje odstęp między obrazkiem a tekstem
    >
      FlexPlum
    </Text>
  </Flex>
)
